import DataTable from "datatables.net";
import {Order} from "datatables.net-bs5";

export default class {
    static init = () => {
        species();
    }
}

function species() {
    new DataTable('.datatable[data-table="species"]',{
        pageLength: 20,
        lengthMenu: [10, 20, 50, 100],
        processing: true,
        serverSide: true,
        ajax: {
            url: '?do=getSpecies',
            data: function (data) {
                return data;
            }
        },
        columns: [
            { data: null, orderable: false, render: function (data, type, row) {
                    return `<div style="background-image:url('${row.sprite}');width:32px;height:32px;background-position: center;background-size: contain;background-repeat: no-repeat;"></div>`;
                }},
            { data: null, render: function (data, type, row) {
                    return `#${row.species_id}`;
                }},
            { data: 'name' },
            { data: 'total', className: 'font-weight-bold' },
            { data: 'max_hp' },
            { data: 'melee_attack' },
            { data: 'ranged_attack' },
            { data: 'melee_defense' },
            { data: 'ranged_defense' },
            { data: 'speed' },
            { data: 'max_ap' },
            { data: 'move_slots' },
            { data: 'record_rate' }
        ],
        order: [[0,"asc"]] as Order[]
    });
}
